<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Src URL extension*:</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.src" @change="saveImage(true)" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow" v-if="!$parent.mediaProperty.configuration.isLocalPath && publicPermission">
            <h4>Access:</h4>
            <select v-model="publicPermission" @change="updatePermissions">
                <option value="public-read">Public</option>
                <option value="private">Private</option>
            </select>
        </div>
        <div class="formRow">
            <h4>Is this a local path?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.isLocalPath" @change="saveImage" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Height (px or %):</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.height" @change="saveImage" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Width (px or %):</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.width" @change="saveImage" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow" v-if="!$parent.mediaProperty.configuration.isLocalPath">
            <h4></h4>
            <UploadMediaPropertyModal openButtonText="Upload Image"
                                        modalTitle="Upload Image"
                                        :fileKey="$parent.mediaProperty.configuration.src"
                                        acceptFileTypes="image/*"
                                        :onFileUpload="onImageUpload"></UploadMediaPropertyModal>
        </div>
        <div class="formRow" v-if="imageLink && !$parent.mediaProperty.configuration.isLocalPath">
            <h4></h4>
            <div>
                <img :src="imageLink" :key="imageKey" style="max-height: 200px; max-width: 200px;"/>
                <div>Not to scale</div>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {storage} from '../../shared/storage';
import UploadMediaPropertyModal from './UploadMediaPropertyModal.vue';

export default {
    name: 'ImageEdit',
    components: { UploadMediaPropertyModal },
    data() {
        return {
            imageKey: 0,
            publicPermission: null,
            imageLink: null
        }
    },
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            return (
                configuration.src &&
                configuration.src.length > 0
            )
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                src: '',
                height: '',
                width: ''
            }
        }

        if(this.$parent.mediaProperty.configuration.src) {
            this.publicPermission = await storage.checkPermission(this.$parent.mediaProperty.configuration.src);
            await this.getImageLink();
        }
    },
    methods: {
        saveImage: async function(updateImage) {
            if(this.validated) {
                this.$parent.mediaProperty.configuration.isPublic = this.publicPermission === 'public-read';
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
                if(updateImage) {
                    await this.getImageLink();
                }
            }
            else
                this.$toast.error('Src is required');
        },
        onImageUpload: async function() {
            this.imageKey++;
            this.publicPermission = await storage.checkPermission(this.$parent.mediaProperty.configuration.src);
            this.saveImage();
        },
        updatePermissions: async function() {
            await storage.updateStoragePermissions(this.$parent.mediaProperty.configuration.src, this.publicPermission, this.imageKey);
        },
        getImageLink: async function() {
            if(this.$parent.mediaProperty.configuration.isLocalPath)
                return;
            this.imageLink = await storage.getWasabiLink(this.$parent.mediaProperty.configuration.src, this.publicPermission === 'public-read');
        }
    }
}
</script>